import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArticleNormalizer } from './connector/article-normalizer';
import { ClassificationAttributeNormalizer } from './connector/classification-attribute-normalizer';
import { ARTICLE_NORMALIZER, CLASSIFICATION_ATTRIBUTE_NORMALIZER } from './connector/converters';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: ARTICLE_NORMALIZER,
      useClass: ArticleNormalizer,
      multi: true,
    },
    {
      provide: CLASSIFICATION_ATTRIBUTE_NORMALIZER,
      useClass: ClassificationAttributeNormalizer,
      multi: true,
    },
  ],
})
export class ArticleModule {}
